import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import {
  AppKitNetwork,
  avalanche,
  base,
  bitcoin,
  bsc,
  dogechain,
  mainnet,
  polygon,
  sepolia,
  tron,
} from '@reown/appkit/networks'
import { createAppKit } from '@reown/appkit/react'
import { captureException } from '@sentry/react'
import { QueryClient } from '@tanstack/react-query'
import { APPKIT_PROJECT_ID, DOMAIN } from './constants'

export const queryClient = new QueryClient()

const metadata = {
  name: 'Penning',
  description: 'Penning AppKit',
  url: DOMAIN, // origin must match your domain & subdomain
  icons: ['https://www.app.penning.dk/favicon.ico'],
}

const networks: [AppKitNetwork, ...AppKitNetwork[]] = [
  mainnet,
  bsc,
  polygon,
  avalanche,
  bitcoin,
  dogechain,
  sepolia,
  base,
  tron,
]

export const networkIsoCodeToWagmiChainMapping: Record<string, number> = {
  ETH: mainnet.id,
  // ETH: sepolia.id,
  BSC: bsc.id,
  MATIC: polygon.id,
  AVAX: avalanche.id,
  DOGE: dogechain.id,
  SEPOLIA: sepolia.id,
  BASE: base.id,
  TRON: tron.id,
}

// Export configuration flags for network environment detection
export const usingEthMainnet =
  networkIsoCodeToWagmiChainMapping.ETH === mainnet.id

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId: APPKIT_PROJECT_ID,
  ssr: true,
})

// 5. Create modal
//
// createAppKit registers the wallet-modal web components and touches a lot of
// browser surface (custom elements, storage, matchMedia, WebSocket). That's the
// call most likely to throw in a restricted in-app browser — and because it runs
// at module import time, an uncaught throw here used to abort evaluation of the
// whole App module and blank the page before anything was reported. It's wrapped
// so the failure is captured and evaluation continues: the modal is only used
// under /app, so public pages (Veli activation, login, sign-up) still render.
// If wagmiAdapter.wagmiConfig itself is unusable, WagmiProvider throws while
// rendering and AppErrorBoundary catches it — either way it's visible + reported,
// never a silent blank.
try {
  createAppKit({
    adapters: [wagmiAdapter],
    networks,
    projectId: APPKIT_PROJECT_ID,
    metadata,
    features: {
      analytics: false,
      swaps: false,
      onramp: false,
    },
    themeMode: 'light',
  })
} catch (err) {
  captureException(err)
}
